import { gql } from '@apollo/client';

export const commentFields = gql`
  fragment CommentFields on Comment {
    author {
      id
      name
      profileImage {
        id
        publicUrl
        publicUrlTransformed
        _meta {
          public_id
          height
          width
        }
      }
      publicAddress
      username
    }
    content
    createdAt
    id
    likesCount(where: { deactivated: { equals: false } })
    likes(where: { id: { equals: $userId }, deactivated: { equals: false } }) {
      id
    }
    childCommentsCount
    parentComment {
      id
    }
  }
`;
